import { useMeeting, usePubSub } from "@videosdk.live/react-sdk";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLogoOffset, setIsLogoDragging } from "../../redux/logoSlice"

const MeetingStyles = () => {
    const audioRef = useRef(null);
    const dispatch = useDispatch();
    const logoData = useSelector((state) => state?.logo);
    const [bannerName, setBannerName] = useState('Default Banner');
    const [backgroundColor, setBackgroundColor] = useState('#00002910');
    const [fontSize, setFontSize] = useState('20px');
    const [logo, setLogo] = useState("");
    const [meetingBackground, setMeetingBackground] = useState("");
    const [meetingOverlay, setMeetingOverlay] = useState("");
    const [bannerTheme, setBannerTheme] = useState(0)

    const [logoPosition, setLogoPosition] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
    const containerRef = useRef(null);
    const [logoWidth, setLogoWidth] = useState('10vh');
    const { publish } = usePubSub("UPDATE_LOGO");

    const [isVisible, setIsVisible] = useState(false);
    const [font, setFont] = useState();
    const position = 'bl';
    const meeting = useMeeting();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const guest = queryParams.get("guest");

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 100);
        return () => clearTimeout(timer);
    }, []);

    const bannerType = [
        {
            transform: isVisible ? 'translateX(0)' : 'translateX(-100%)',
            borderRadius: '0.5vh',
            bottom: '0.4vh',
            left: position === 'cc' ? '50%' : '0.8vh',
        },
        {
            // marginLeft: '1vh',
            bottom: '0.4vh',
            left: position === 'cc' ? '50%' : '0.8vh',
        }, {
            // marginLeft: '1vh',
            borderRadius: '100px',
            bottom: '0.4vh',
            left: position === 'cc' ? '50%' : '0.8vh',
        }, {
            clipPath: isVisible
                ? 'polygon(0% 100%, 98% 100%, 100% 0%, 0% 0%)'
                : 'polygon(0% 100%, 0% 100%, 0% 0%, 0% 0%)',
            borderTopRightRadius: '1vh',
            bottom: '0vh',
            left: position === 'cc' ? '50%' : '0vh',
        }
    ]

    // Convert px to vh
    const convertPxToVh = (pxValue) => {
        if (!pxValue) return '1.6vh';
        const numericValue = Number.parseFloat(pxValue);
        if (Number.isNaN(numericValue)) return '1.6vh';
        const vhValue = numericValue * 0.1;
        return `${vhValue.toFixed(2)}vh`;
    };

    usePubSub("UPDATE_BANNER", {
        onMessageReceived: (data) => {
            const { message } = data;
            setBannerName(message?.message || '');
            setBackgroundColor(message?.message ? message?.backgroundColor : 'transparent');
            setFontSize(convertPxToVh(message?.fontSize));
            setBannerTheme(message?.bannerStyle ? message?.bannerStyle : 0)
            setFont(message?.font);
        },
        onOldMessagesReceived: (messages) => {
            if (messages && messages.length > 0) {
                const latestMessage = messages[messages.length - 1].message;
                setBannerName(latestMessage?.message || '');
                setBackgroundColor(latestMessage?.message ? latestMessage?.backgroundColor : 'transparent');
                setFontSize(convertPxToVh(latestMessage?.fontSize));
                setBannerTheme(latestMessage?.bannerStyle ? latestMessage?.bannerStyle : 0)
            }
        },
    });

    usePubSub("UPDATE_LOGO", {
        onMessageReceived: (data) => {
            const { message } = data;
            console.log('message', message);
            setLogo(message?.LogoUrl);
            setLogoWidth(message?.width);
            if (message.LogoAxisX || message.LogoAxisY) {
                setLogoPosition({ x: message.LogoAxisX, y: message.LogoAxisY });
            }
        },
        onOldMessagesReceived: (messages) => {
            // Check if any old message exists, and if so, set it to the state
            console.log("logo", messages)
            if (messages && messages.length > 0) {
                const latestMessage = messages[messages.length - 1].message; // Get the most recent banner message
                setLogo(latestMessage?.LogoUrl);
                setLogoWidth(latestMessage?.width);
            }
        },
    });

    usePubSub("UPDATE_MEETING_BACKGROUND", {
        onMessageReceived: (data) => {
            const { message } = data;
            setMeetingBackground(message?.BackgroundUrl);
        },
        onOldMessagesReceived: (messages) => {
            // Check if any old message exists, and if so, set it to the state
            if (messages && messages.length > 0) {
                const latestMessage = messages[messages.length - 1].message.BackgroundUrl; // Get the most recent banner message
                setMeetingBackground(latestMessage);
            }
        },
    });

    usePubSub("UPDATE_MEETING_OVERLAY", {
        onMessageReceived: (data) => {
            const { message } = data;
            setMeetingOverlay(message?.OverlayUrl);
            console.log(meetingOverlay);
        },
        onOldMessagesReceived: (messages) => {
            // Check if any old message exists, and if so, set it to the state
            if (messages && messages.length > 0) {
                const latestMessage = messages[messages.length - 1].message.OverlayUrl; // Get the most recent banner message
                console.log(latestMessage)
                setMeetingOverlay(latestMessage);
            }
        },
    });

    usePubSub("UPDATE_MUSIC", {
        onMessageReceived: (data) => {
            const { action, url } = data;

            if (!audioRef.current) {
                audioRef.current = new Audio(url); // Create the audio element if it doesn't exist
            }

            const audio = audioRef.current;

            if (action === "play" && url) {
                audio.src = url; // Set the audio URL when playing
                audio.play();
            } else if (action === "pause") {
                audio.pause();
            }
        },

        onOldMessagesReceived: (messages) => {
            if (messages && messages.length > 0) {
                const { action, url } = messages[messages.length - 1].data;

                if (!audioRef.current) {
                    audioRef.current = new Audio(url); // Create the audio element if it doesn't exist
                }

                const audio = audioRef.current;

                if (action === "play" && url) {
                    audio.src = url;
                    audio.play();
                } else if (action === "pause") {
                    audio.pause();
                }
            }
        },
    });
    const bannerStyles = {
        ...bannerType[bannerTheme],
        position: 'absolute',
        // left: position === 'cc' ? '50%' : '0',
        // transform: position === 'cc' ? 'translateX(-50%)' : 'none',
        // transition: 'all 0.9s ease-out',
        opacity: isVisible ? 1 : 0,
        backgroundColor: backgroundColor,
        color: 'white',
        fontSize: fontSize,
        padding: '2vh 3%',
        // textAlign: 'center',
        zIndex: 1000,
        height: 'auto',
        minHeight: '4.5vh',
        lineHeight: '0.12vh',
        overflow: 'hidden',
        wordWrap: 'break-word',
        whiteSpace: 'normal',
        maxWidth: '75%',
        // color: 'White',
        paddingLeft: '3%',
        paddingRight: '3%',
        fontWeight: '600',
        // left: position === 'cc' ? '50%' : (guest ? '0' : '80px'),
        transform: position === 'cc' ? 'translateX(-50%)' : 'none',
        fontFamily: font
    };

    const handleMouseDown = (e) => {
        e.preventDefault();
        const { left, top } = e.currentTarget.getBoundingClientRect();
        const offsetX = e.clientX - left;
        const offsetY = e.clientY - top;
        setDragOffset({
            x: offsetX,
            y: offsetY
        });
        setIsDragging(true);
        dispatch(setLogoOffset({
            offsetX: offsetX,
            offsetY: offsetY
        }))
        dispatch(setIsLogoDragging(true))
    };



    return (
        <div>
            {
                (bannerName !== 'Default Banner' || !bannerName) && (
                    <div
                        style={bannerStyles}
                    >
                        {bannerName}
                    </div>
                )
            }
            {
                (logo !== null && logo !== "") && (
                    <div
                        style={{
                            display: 'none',
                        }}
                    />
                )
            }
        </div>
    )
}

export default MeetingStyles;